import Vue from 'vue';
import Component from 'vue-class-component';
import FilterBox from './components/filterBox/filterBox';
import BrainCard from './components/brainCard/brainCard';
import moduleStore from '../videoEditor/store/videoEditor';
import ConfirmDialog from '../../components/confirm-dialog/confirm-dialog.vue';
import { toast } from '@/utils/util';

@Component({
  components: {
    FilterBox,
    BrainCard,
    ConfirmDialog
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class BrainHistory extends Vue {
  // 类别集合
  typeList = [
    {
      type: '',
      title: '全部类别'
    },
    {
      type: 'CITATION',
      title: '黄金开场'
    },
    {
      type: 'TITLE',
      title: '智能标题'
    },
    {
      type: 'DESC',
      title: '智能描述'
    },
    {
      type: 'REWRITE',
      title: '智能改写'
    },
    {
      type: 'TEXT_IMG',
      title: '文生图'
    },
    // {
    //   type: 'CONVER_IMG',
    //   title: '智能生图'
    // }
  ];
  // 当前选择type
  activeTypeInfo = {
    type: '',
    title: '全部类别'
  };
  // 当前时间
  showDate = '全部日期';
  minDate = new Date(2020, 0, 1);
  maxDate = new Date();
  // 是否显示日期组件
  showPicker = false;

  // 历史数据
  brainDataList = [];
  // 是否加载
  loading = false;
  // 是否加载完成
  finished = false;
  isRest = false;
  pageSize = 10;
  pageNum = 0;
  total_pages = 10
  createStartDate = '';
  createEndDate = ''
  showConfirmDialog = false;
  // 当前数据
  currentData = null;
  miniPageMap = {
    1: 'ai-title/ai-title',
    2: 'ai-description/ai-description',
    3: 'ai-gold-start/ai-gold-start',
    4: 'ai-rewrite/ai-rewrite',
    5: 'ai-image/ai-image'
  }
  mounted() {
    const source = this.$route.query.type
    if (source) {
     this.activeTypeInfo = this.typeList.find((item) => item.type === source)
    }
  }
  /**
   * 获取生成记录
   */
  getBrainHistoryList() {
    const params = {
      page: this.pageNum,
      size: this.pageSize,
      type: this.activeTypeInfo.type,
      createStartDate: this.createStartDate || null,
      createEndDate: this.createEndDate || null
    }
    this.$http('getBrainRecordList', params).then((res) => {
      if (res.code === 200) {
        const { total_pages, results } = res.data
        this.total_pages = total_pages
        console.log('getBrainRecordList---' + this.pageNum, results)
        if (results && results.length) {
          this.brainDataList = this.brainDataList.concat(results)
        }
        // this.brainDataList = this.brainDataList.concat(list)
        this.loading = false
      }
    }).finally(() => {
      this.isRest = false
    })
  }
  /**
   * 选择当前type
   * @param type
   */
  selectType(typeInfo) {
    if (typeInfo.type === this.activeTypeInfo.type) return;
    this.activeTypeInfo = typeInfo;
    this.pageNum = 1;
    this.brainDataList = [];
    this.finished = false;
    this.loading = false;
    this.getBrainHistoryList()
  }
  selectAllDate() {
    this.showDate = '全部日期';
    if (this.createStartDate) {
      this.pageNum = 1
      this.brainDataList = []
      this.createStartDate = null
      this.createEndDate = null;
      this.getBrainHistoryList()
    }
  }
  handleShowDate() {
    this.showPicker = true;
  }
  resetType() {
    this.showDate = '全部日期';
    this.activeTypeInfo = this.typeList[0];
    this.pageNum = 1;
    this.brainDataList = [];
    this.createStartDate = null
    this.createEndDate = null;
    this.loading = false;
    this.finished = false;
    this.isRest = true
    this.getBrainHistoryList();

  }
  closePicker() {
    this.showPicker = false;
  }
  //格式化日期
  formatDate(date, type = '') {
    let year = date.getFullYear();
    let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return type == 'dot' ? `${year}.${month}.${day}` : `${year}/${month}/${day}`;
  }
  /**
   * 确定选择时间
   */
  confirmPicker(date) {
    this.showDate = this.formatDate(date[0],'dot') + '-' + this.formatDate(date[1],'dot')
    this.showPicker = false;
    const dateStr = new Date(this.formatDate(date[0]) + ' 00:00').toJSON()
    const endDateStr = new Date(this.formatDate(date[1]) + ' 23:59:59').toJSON()
    if (this.createStartDate !== dateStr || this.createEndDate !== endDateStr) {
      this.pageNum = 1
      this.brainDataList = []
      this.createStartDate = dateStr
      this.createEndDate = endDateStr
      this.getBrainHistoryList()
    }
    if(this.$refs.filterBoxRef) {
      (this.$refs.filterBoxRef as any).closeDatePopover()
    }
  } 
  onLoad() {
    if (this.isRest) return
    if (this.pageNum < this.total_pages) {
      this.loading = true
      this.finished = false
      this.pageNum = this.pageNum + 1;
      this.getBrainHistoryList()
    } else {
      this.loading = false
      this.finished = true
    }
    
    // this.finished = true
  }
  /**
   * 删除当前条目
   * @param data
   */
  deleteBrain(data) {
    this.currentData = data
    this.showConfirmDialog = true
  }
  /**
   * 重新生成
   * @param data
   */
  anewGenerate(data) {
    console.log('anewGenerate', this.miniPageMap[data.type])
    this.$navigateTo({
      url: `/package-tools/pages/${this.miniPageMap[data.type]}?id=${data.id}`,
    })
  }
  /**
   * 确认删除
   */
  confirmDelete() {
    this.showConfirmDialog = false
    this.$http('deleteRecord', {recordId: this.currentData.id}).then((res) => {
      console.log('confirmDelete', res)
      if (res.code === 200 && res.data === 1) {
        toast('删除成功')
        this.pageNum = 1
        this.brainDataList = []
        this.getBrainHistoryList()
      } else {
        toast('删除失败')
      }
    })
  }
}